import {useCallback} from "react";
import {getSubmit, postSubmit} from "ui-seeker/utils";
import {useToaster} from "ui-seeker/core";

export default function useAjaxButton () {
    const { showToaster } = useToaster()
    const onClick = useCallback(({urlAjax, data, method, onAjax, customToast}) => {
        if (!urlAjax) return;
        showToaster.loading()
        method?.toUpperCase() === "POST" ?
            postSubmit(urlAjax, data).then((response) => {
                if (!customToast) showToaster.success()
                onAjax?.(response)
            }).catch(res => showToaster.error(res?.error))
            :
            getSubmit(urlAjax).then((response) => {
                if (!customToast) showToaster.success()
                onAjax?.(response)
            }).catch(res => showToaster.error(res?.error));
    }, []);

    return { onClick };
}
